import { Application } from "stimulus"

import FormController               from "controllers/form_controller"
import SurveyResponseController     from "controllers/survey_response_controller"
import ContentLoaderController      from "controllers/content_loader/survey_controller"
import DirectUploadsController      from "controllers/direct_uploads_controller"
import AutogrowTextareaController   from "controllers/autogrow_textarea_controller"
import BooleanController            from "controllers/question/boolean_controller"
import IntegerController            from "controllers/question/integer_controller"
import LocationController           from "controllers/question/location_controller"
import LongTextController           from "controllers/question/long_text_controller"
import MultipleChoiceController     from "controllers/question/multiple_choice_controller"
import RankingController            from "controllers/question/ranking_controller"
import ScaleController              from "controllers/question/scale_controller"
import ShortTextController          from "controllers/question/short_text_controller"
import InitialiseAudio              from "controllers/initialise_audio_controller"
import ScrollableController         from "controllers/scrollable_controller"
import RecordAudioController        from "../controllers/record_audio_controller"

// import ScaleAnswerController        from "controllers/answer/scale_controller"

const application = Application.start()
application.register("form", FormController)
application.register("survey-response", SurveyResponseController)
application.register("content-loader--survey", ContentLoaderController)
application.register("direct-uploads", DirectUploadsController)
application.register("autogrow-textarea", AutogrowTextareaController)

application.register("question--boolean", BooleanController)
application.register("question--integer", IntegerController)
application.register("question--location", LocationController)
application.register("question--long-text", LongTextController)
application.register("question--multiple-choice", MultipleChoiceController)
application.register("question--ranking", RankingController)
application.register("question--scale", ScaleController)
application.register("question--short-text", ShortTextController)
// application.register("answer--scale", ScaleAnswerController)

application.register("initialise-audio", InitialiseAudio)
application.register("scrollable", ScrollableController)
application.register("record-audio", RecordAudioController)
